import React from 'react';
import './Chapters.scss';

function Chapter4() {
  return (
    <section className="chapter">
      <p className="chapter__title">Letting Scientists Do Science, Not IT</p>
      <p className="chapter__paragraph">
        Working with datasets can be a challenge for researchers when it comes to technology.
        Scientists want to invest their time in doing science, not struggling to understand the
        mechanisms behind a software platform or managing the backend of data processing. More
        importantly, when large dataset analysis takes massive computational power, that data load
        needs to be managed to operate efficiently.
      </p>
      <p className="chapter__paragraph">
        To free its scientists from the burden of database management, the TSI team turned to a
        web-and-desktop–based platform called{' '}
        <a href="https://ronin.cloud/" target="_blank" rel="noreferrer">
          RONIN
        </a>
        . RONIN, which runs on AWS and{' '}
        <a
          href="https://www.intel.com/content/www/us/en/products/details/processors/xeon/scalable.html"
          target="_blank"
          rel="noreferrer"
        >
          Intel<sup>®</sup> Xeon<sup>®</sup> Scalable processors
        </a>
        , helps researchers stand up virtual workstations and supercomputing clusters at a moment’s
        notice via an easy-to-use interface. It also allows them to scale back to preserve precious
        research funds when work is complete, paying only for the compute that they use.
      </p>
      <p className="chapter__paragraph">
        For researchers without a robust IT department to set up projects and manage computing
        funds, RONIN provides a running tally of how much each cloud computing environment costs at
        any given moment. The dashboard shows them how much funding they can free up for new
        projects by dialing back resources on inactive ones.
      </p>
    </section>
  );
}

export default Chapter4;
